import { GetGuestConnect } from 'core/API/workplaces';
import Loading from 'core/components/Loading/Loading';
import { useQuery } from 'react-query';
import { useWorkplacesContext } from 'module/workplaces/context/WorkplacesContext';
import { useWorkplaceUser } from 'module/documents/utils';
import GuestConnect from './GuestConnect';

/**
 * GuestConnectContainer
 * 
 * Fetches guest connect settings for the current workplace and renders the campaign management dashboard.
 * Now integrated within the Layout component with sidebar navigation.
 */
export default function GuestConnectContainer(): JSX.Element {
	const { workplaceId } = useWorkplacesContext();
	const { userOrg } = useWorkplaceUser();

	// Fetch guest connect settings for the current workplace
	const { data: settings, isLoading } = useQuery(
		['GuestConnect', workplaceId],
		() => GetGuestConnect(workplaceId?.toString()),
		{
			enabled: !!workplaceId,
		}
	);

	if (isLoading || !workplaceId) {
		return <Loading />;
	}

	// Pass organizationId and settings to GuestConnect component
	return (
		<GuestConnect 
			organizationId={userOrg?.id?.toString() || ''}
			settings={settings}
		/>
	);
}
